import { CampaignDefineFormData } from 'components/campaigns/forms/CreateCampaignDefine';
import { Campaign } from 'components/campaigns/models/Campaign';
import { CampaignItem } from 'components/campaigns/models/CampaignItem';
import { removeArrayItem, updateArrayItem } from 'lib/helpers';
import { ICampaignsAction } from './campaignsAction';
import { CampaignsActionType } from './campaignsActionTypes';

const dummyCampaignItem: CampaignItem = {
    effect: null,
    condition: null
};

export interface CampaignsState {
    campaigns: Campaign[];
    currentCampaign: CampaignDefineFormData & { id?: string };
    isLoading: boolean;
    campaignItems: CampaignItem[];
    campaignItemsCopy: CampaignItem[];
    createPerkModalIndex: number;
    createPerkModalTitle: string;
    createAudienceModalIndex: number;
    createAudienceModalTitle: string;
    createVoucherModalIndex: [number, number];
    createVoucherModalTitle: string;
    discardAudienceCreationOpen: boolean;
    discardPerkCreationOpen: boolean;
    discardVoucherCreationOpen: boolean;
}

export const initialState: CampaignsState = {
    campaigns: [],
    currentCampaign: null,
    isLoading: false,
    campaignItems: [dummyCampaignItem],
    campaignItemsCopy: [],
    createPerkModalIndex: -1,
    createAudienceModalIndex: -1,
    createVoucherModalIndex: null,
    createVoucherModalTitle: '',
    createPerkModalTitle: '',
    createAudienceModalTitle: '',
    discardAudienceCreationOpen: false,
    discardPerkCreationOpen: false,
    discardVoucherCreationOpen: false
};

export default function (state: CampaignsState = initialState, action: ICampaignsAction): CampaignsState {
    switch (action.type) {
        case CampaignsActionType.START_REQUEST:
            return { ...state, isLoading: true };
        case CampaignsActionType.END_REQUEST:
            return { ...state, isLoading: false };
        case CampaignsActionType.CREATE_CAMPAIGN_SUCCESS:
            return { ...state, currentCampaign: action.campaign };
        case CampaignsActionType.TOGGLE_CREATE_AUDIENCE_MODAL:
            return {
                ...state,
                createAudienceModalIndex: action.index,
                createAudienceModalTitle: action.title
            };
        case CampaignsActionType.TOGGLE_CREATE_PERK_MODAL:
            return { ...state, createPerkModalIndex: action.index, createPerkModalTitle: action.title };
        case CampaignsActionType.TOGGLE_CREATE_VOUCHER_MODAL:
            return { ...state, createVoucherModalIndex: action.index, createVoucherModalTitle: action.title };
        case CampaignsActionType.UPDATE_CAMPAIGN_ITEM: {
            const newCampaignItems = updateArrayItem(state.campaignItems, action.index, action.campaignItem);
            return { ...state, campaignItems: newCampaignItems };
        }
        case CampaignsActionType.ADD_EMPTY_CAMPAIGN: {
            const newCampaignItems = [...state.campaignItems, dummyCampaignItem];
            return { ...state, campaignItems: newCampaignItems };
        }
        case CampaignsActionType.CRUD_CAMPAIGNS_ABORT:
            return { ...state, campaignItems: [...state.campaignItemsCopy] };
        case CampaignsActionType.CRUD_CAMPAIGNS_SUCCESS:
            return { ...state, campaignItemsCopy: [...state.campaignItems] };
        case CampaignsActionType.UPDATE_CAMPAIGN_EFFECT_TARGET: {
            const index =
                state.createAudienceModalIndex > -1
                    ? state.createAudienceModalIndex
                    : state.createPerkModalIndex;
            const currentCampaignItem: CampaignItem = state.campaignItems[index];
            const campaignItem: CampaignItem = {
                ...currentCampaignItem,
                effect: { ...currentCampaignItem.effect, target: action.target }
            };
            return { ...state, campaignItems: updateArrayItem(state.campaignItems, index, campaignItem) };
        }
        case CampaignsActionType.UPDATE_CAMPAIGN_CONDITION_VARIANT_VALUE: {
            const [outerIndex, innerIndex] = state.createVoucherModalIndex;
            const currentCampaignItem: CampaignItem = state.campaignItems[outerIndex];
            const campaignItem: CampaignItem = {
                ...currentCampaignItem,
                condition: {
                    ...currentCampaignItem.condition,
                    value: updateArrayItem(currentCampaignItem.condition.value, innerIndex, {
                        ...currentCampaignItem.condition.value[innerIndex],
                        value: action.value
                    })
                }
            };
            return {
                ...state,
                campaignItems: updateArrayItem(state.campaignItems, outerIndex, campaignItem)
            };
        }
        case CampaignsActionType.DISCARD_CAMPAIGN_AUDIENCE_CREATION:
            return { ...state, discardAudienceCreationOpen: true };
        case CampaignsActionType.DISCARD_CAMPAIGN_PERK_CREATION:
            return { ...state, discardPerkCreationOpen: true };
        case CampaignsActionType.DISCARD_CAMPAIGN_VOUCHER_CREATION:
            return { ...state, discardVoucherCreationOpen: true };
        case CampaignsActionType.CLOSE_CAMPAIGN_MODALS:
            return {
                ...state,
                createPerkModalIndex: -1,
                createAudienceModalIndex: -1,
                createVoucherModalIndex: null,
                createAudienceModalTitle: '',
                createPerkModalTitle: '',
                createVoucherModalTitle: '',
                discardAudienceCreationOpen: false,
                discardPerkCreationOpen: false,
                discardVoucherCreationOpen: false
            };
        case CampaignsActionType.CLOSE_CAMPAIGN_DISCARD_MODALS:
            return {
                ...state,
                discardAudienceCreationOpen: false,
                discardPerkCreationOpen: false,
                discardVoucherCreationOpen: false
            };
        case CampaignsActionType.DELETE_CAMPAIGN_ITEM:
            return { ...state, campaignItems: removeArrayItem(state.campaignItems, action.index) };
        case CampaignsActionType.LOAD_CAMPAIGN_SUCCESS:
            return { ...state, currentCampaign: action.campaign, campaignItems: action.campaignItems };
        default:
            return state;
    }
}
